import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

interface ClaimItem {
  no: string;
  html: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentClaims',
  props: {
  patent: { required: true, default: () => ({}), type: Object },
},
  setup(__props) {

const props = __props;



const claimItems = computed<ClaimItem[]>(() => {
  const claims: string = props.patent?.patentText?.claims || "";
  if (!claims.trim()) {
    return [];
  }

  // 按权利要求编号拆分: 支持 "1." "1、" "1，" 开头, 兼容 <br/> 与 \n 分隔的原文
  const normalized = claims.replace(/\r?\n/g, "<br/>");
  const parts = normalized
    .split(/(?:^|<br\s*\/?>)\s*(?=\d{1,3}[\.、，])/)
    .map((part: string) => part.replace(/^<br\s*\/?>/, "").trim())
    .filter((part: string) => !!part);

  return parts.map((part: string) => {
    const match = part.match(/^(\d{1,3})\s*[\.、，]\s*([\s\S]*)$/);
    const no = match ? match[1] : "";
    let body = match ? match[2] : part;
    // 引用其他权利要求的描述显示为斜体
    body = body.replace(/(根据权利要求[\d\-、,和至]+(?:所述的)?[^<。，]{0,20})/g, "<span class='claim-ref'>$1</span>");
    return { no, html: body };
  });
});

return { __sfc: true,props, claimItems }
}

})